module.exports = {"title":"Sorry!","description":"The browser you are using is not supported.<br />Please come back using Chome, Safari or Firefox.","close":"Close"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Payout/InvoiceModal/locales/fr.json
// module id = 1953
// module chunks = 0